import { Component, OnInit, EventEmitter, Output, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-delete-contact-dialog",
  templateUrl: "./delete-contact-dialog.component.html",
  styleUrls: ["./delete-contact-dialog.component.scss"],
})
export class DeleteContactDialogComponent implements OnInit {
  @Output() delete: EventEmitter<any> = new EventEmitter();

  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close(true);
  }

  deleteContact() {
    this.delete.emit(true);
  }
}
